import { useRef, useEffect } from 'react';

const usePrev = (value: any) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export { usePrev };
